import { useGame } from "~/app";
import { XOpponentInfos } from "~/jsx/components/design";

export const XOpponents = () => {
  const { game } = useGame();
  const { players, currentPlayerIndex, firstPlayerIndex } = game;

  return (
    <div style={{ position: "relative" }}>
      {players.map((player, index) => (
        <div key={index} style={{ display: "flex", alignItems: "center" }}>
          <XOpponentInfos
            player={player}
            isCurrent={index === currentPlayerIndex}
            isFirst={index === firstPlayerIndex}
          />
        </div>
      ))}
    </div>
  );
};
